/** SoBooster APP API **/
$(window).on('popstate', function(event) {
 initLoadScript();
}); 

/**  Get all selected value  **/
   
var collection_id = $("#collection_id").val();
var boosterAPI = '931d7ec7-b0df-4151-be2a-c1665f0233c2';

function getSelectedVal(x){

  /** Multiselected style value in array **/  
  var styleArr = new Array(); 
  var shapeArr = new Array(); 
  var styleArrUrl = new Array(); 
  var currentURL = window.location.search;
  var facetItem = {};
  var newurl = currentURL;
  var metal ="";

  if(x != 1){
  /** Budget value **/
  var min_budget = $(".budget-num-start").val();
  var max_budget = $(".budget-num-end").val();
  min_budget = parseFloat(min_budget.replace('$ ', '').replace(/,/g, ''));
  max_budget = parseFloat(max_budget.replace('$ ', '').replace(/,/g, ''));

  facetItem[1591813151]  =  ["price",[":"+min_budget+" :"+max_budget]];
  
   $("input.budget-num-start").val("$ " + Number(min_budget).toLocaleString('en')).change();
   $("input.budget-num-end").val("$ " + Number(max_budget).toLocaleString('en')).change();
   
  newurl = addOrUpdateUrlParam(newurl, 'price_min', min_budget);
  newurl = addOrUpdateUrlParam(newurl, 'price_max', max_budget);
            console.log("price_min-price_max")

  }else{
    newurl = removeParam("price_min", newurl); 
    newurl = removeParam("price_max", newurl); 
  }
  $("#shopStyle input[name='style']:checked").each(function () {
    var style = $(this).val();
     styleArrUrl.push(style.replaceAll(" ", "+"));  
     styleArr.push(style);   
  }); 
  
  if (styleArr.length != 0) {    
     facetItem[1490488825]  =  ["tags",styleArr];
     newurl = addOrUpdateUrlParam(newurl, 'style',styleArrUrl);   
  }else{
       newurl = removeParam("style", newurl); 
  }

   $("#MoreFilters input[name='diamond_shape']:checked").each(function () {
    var shape = $(this).val();
     shapeArr.push(shape);  
  }); 
  
  if (shapeArr.length != 0) {    
     facetItem[2008783349]  =  ["tags",shapeArr];
     newurl = addOrUpdateUrlParam(newurl, 'diamond',shapeArr);   
  }else{
        newurl = removeParam("diamond", newurl);  
  } 

  /** Metal selected **/ 
  var metalArr = new Array(); 
    var metalArrUrl = new Array(); 
   $("input[name='inlineRadioMetal']:checked").each(function () {
      metal = $(this).val();
      metalArrUrl.push(metal.replaceAll(" ", "+")); 
     metalArr.push(metal); 
   });
  var metalArrNew = new Array(); 
   if (metalArr.length != 0) {

       if(metalArr == 'Yellow Gold'){
       metalArrNew = ['YELLOW GOLD', '18K YELLOW GOLD', '14K YELLOW GOLD', '10K YELLOW GOLD', 'Yellow Gold', '18K Yellow Gold', '14K Yellow Gold', '10K Yellow Gold'];
     }else if(metalArr == 'Rose Gold'){
       metalArrNew = ['ROSE GOLD', '18K ROSE GOLD', '14K ROSE GOLD', '10K ROSE GOLD', 'Rose Gold', '18K Rose Gold', '14K Rose Gold', '10K Rose Gold'];   
     }else if(metalArr == 'White Gold'){
       metalArrNew = ['WHITE GOLD', '18K WHITE GOLD', '14K WHITE GOLD', '10K WHITE GOLD', 'White Gold', '18K White Gold', '14K White Gold', '10K White Gold'];
       
     }else if(metalArr == 'Silver'){
       metalArrNew = ['STERLING SILVER', '18K AND STERLING SILVER','PLATINUM', 'Sterling Silver', '18K And Sterling Silver','Platinum'];    
     }else if(metalArr == 'Two Toned'){
       metalArrNew = ['14K TWO TONE GOLD', '18K TWO TONE GOLD', '14K WHITE GOLD / ROSE GOLD', '14K Two Tone Gold', '18K Two Tone Gold', '14K White Gold / Rose Gold'];    
     }

     
      facetItem[1352577410]  =  ["option:Metal",metalArrNew];
      newurl =( addOrUpdateUrlParam(newurl, 'metal',metalArrUrl));
  }

    var designerArr = new Array(); 
   var designerArrUrl = new Array(); 
   $("#MoreFilters input[name='designer_name']:checked").each(function () {
      designer = $(this).val();
      designerArr.push(designer); 
      designer = designer.replaceAll(" ", "+");  
      designerArrUrl.push(designer.replaceAll("&", "%26"));  
     
   });
   if (designerArr.length != 0) {
      facetItem[2041182555]  =  ["tags",designerArr];
      newurl =( addOrUpdateUrlParam(newurl, 'designer',designerArrUrl));
  }else{
        newurl = removeParam("designer", newurl); 
  } 

  /** Sorting Option **/
  var sortBy = ($("select[name='sortBy'] option:selected").val());
  if($.trim(sortBy) != "" ){  
      newurl = addOrUpdateUrlParam(newurl, 'sortby', sortBy);    
  }
  
  /** Items Per Page **/
   var itemsPerPage = ($("select[name='itemsPerPage'] option:selected").val());
  if($.trim(itemsPerPage) != "" ){  
      newurl = addOrUpdateUrlParam(newurl, 'itemsPerPage', itemsPerPage);    
  }else{
      itemsPerPage = 20;
  }

  var collection_title =  $('.page_title').val();
  $('title').html(metal +' '+ styleArr +' '+ shapeArr +' '+ collection_title);
  
  jsonFacet = JSON.stringify(facetItem);
  window.history.pushState(null, '', newurl);
  searchBoosterAPI(jsonFacet, sortBy, itemsPerPage, metal );  
}

/***  First product load on PLP ***/

function initLoadScript(){
  
  var facetItem = {};
  var style = getUrlParameter('style');
  var metal = getUrlParameter('metal');
   var diamond = getUrlParameter('diamond');
  var designer = getUrlParameter('designer');
  var price_min = getUrlParameter('price_min');
  var price_max = getUrlParameter('price_max');
  var sortby = getUrlParameter('sortby');
  var itemsPerPage = getUrlParameter('itemsPerPage');

  var collection_title =  $('.page_title').val();
  $('title').html(metal +' '+ style +' '+ diamond +' '+ collection_title);
  

  if($.trim(style) != ""){   
    
    $("input[name='style']").prop("checked", false);
      var styleArray = style.split(',');
      for (var i = 0; i < styleArray.length; ++i) {
        $("input[name='style'][value='"+styleArray[i]+"']").prop("checked", true);
      } 
     facetItem[1490488825]  =  ["tags",styleArray];

  }else{
    $("input[name='style']").prop("checked", false);
  }

    if($.trim(diamond) != ""){   
    
    $("input[name='diamond_shape']").prop("checked", false);
      var shapeArray = diamond.split(',');
      for (var i = 0; i < shapeArray.length; ++i) {
        $("input[name='diamond_shape'][value='"+shapeArray[i]+"']").prop("checked", true);
      } 
     facetItem[2008783349]  =  ["tags",shapeArray];
       $("a.moreFilter").removeClass("collapsed");
         $("#MoreFilters").addClass("show");

  }else{
    $("input[name='shapeArray']").prop("checked", false);
  }

   if($.trim(metal) != ""){     
     $("input[name='inlineRadioMetal'][value='"+metal+"']").prop("checked", true);  
       $("input[name='inlineRadioMetal2'][value='"+metal+"']").prop('checked', true);
      facetItem[1352577410]  =  ["option:Metal",[metal]];
  } else{
    $("input[name='inlineRadioMetal']").prop("checked", false);
  }

  if($.trim(designer) != ""){   
    
    $("input[name='designer_name']").prop("checked", false);
      var designerArray = designer.split(',');
      for (var i = 0; i < designerArray.length; ++i) {
        $("input[name='designer_name'][value='"+designerArray[i]+"']").prop("checked", true);
      } 
  var designCheck = new Array(); 
       $("input[name='designer_name']:checked").each(function () {
     designCheck.push($(this).val()); 
        
   });
     console.log("Designer CHeck " + designCheck.length );
  if(designCheck.length > 0){
    if(designCheck.length > 3){
      $(".designer_multiselector").find('button').text(designCheck.length + " Designers selected");
    }else{
       $(".designer_multiselector").find('button').text(designer);
    }
        $("a.moreFilter").removeClass("collapsed");
         $("#MoreFilters").addClass("show");
  }
     facetItem[2041182555]  =  ["tags",designerArray];

  }else{
    $("input[name='designer_name']").prop("checked", false);
  }
  

 $(".sortListP a.list-group-item").removeClass("active");
   if($.trim(sortby) != ""){
       $("select[name='sortBy']").val(sortby); 
    $(".sortListP a.list-group-item[data-value='"+sortby+"']").addClass("active");
  }else{
    $("select[name='sortBy']").val("");
     $(".sortListP a.list-group-item[data-value='']").addClass("active");
  }

   if($.trim(itemsPerPage) != ""){
       $("select[name='itemsPerPage']").val(itemsPerPage); 
  }else{
     itemsPerPage = 20;
    $("select[name='itemsPerPage']").val(20);
  }

   if($.trim(price_min) != "" || $.trim(price_max) != ""){
      $("input.budget-num-start").val("$ " + Number(price_min).toLocaleString('en')).change();
      $("input.budget-num-end").val("$ " + Number(price_max).toLocaleString('en')).change();
      var keypressSlider = document.querySelector(".budget-range");
      var budgetMinPress = document.querySelector(".budget-range-min");
 
     var inputs = [price_min, price_max];
     keypressSlider.noUiSlider.set(inputs);
     budgetMinPress.noUiSlider.set(inputs);
       $("a.moreFilter").removeClass("collapsed");
         $("#MoreFilters").addClass("show");
     facetItem[1591813151]  =  ["price",[":"+price_min+" :"+price_max]];
             console.log("price_min-price_max")

   
  }
  jsonFacet = JSON.stringify(facetItem);
  searchBoosterAPI(jsonFacet, sortby, itemsPerPage, metal );
  
}

function searchBoosterAPI(faceFilter, sortBy, itemsPerPage, metal){

  var page = 1;
  
  var skip = 0;
  if( $.trim(getUrlParameter('page')) != ""){
    page = getUrlParameter('page');
    skip = (page-1)*itemsPerPage;

  }

 
 /*** URL https://svc-1001-usf.hotyon.com/search?q=&apiKey=931d7ec7-b0df-4151-be2a-c1665f0233c2&locale=en&getProductDescription=0&collection=416955990234&facetFilters=%7B%221352577410%22%3A%5B%22option%3AMetal%22%2C%5B%22Rose%20Gold%22%5D%5D%2C%221490488825%22%3A%5B%22tags%22%2C%5B%22%20Bezel_set%22%2C%22%20Bespoke%22%5D%5D%2C%221591813151%22%3A%5B%22price%22%2C%5B%22%3A2111.1%20%3A5125.5%22%5D%5D%2C%222008783349%22%3A%5B%22tags%22%2C%5B%22oval%22%2C%22Emerald%22%5D%5D%2C%222041182555%22%3A%5B%22tags%22%2C%5B%22Christopher%22%5D%5D%7D&skip=0&take=28  **/
 if($.trim(sortBy) != ""){
   var query = { q: "", 
         apiKey: boosterAPI,
         locale: 'en',
         getProductDescription: 0,
         collection: collection_id,
         facetFilters: faceFilter,
         skip: skip,
         take: itemsPerPage,
         sort: sortBy
        };
 }else{
    var query = { q: "", 
         apiKey: boosterAPI,
         locale: 'en',
         getProductDescription: 0,
         collection: collection_id,
         facetFilters: faceFilter,
         skip: skip,
         take: itemsPerPage
        };
 } 
   $("#ProductGridContainer #product-grid").html('<div class="loader"><img src="https://cdn.shopify.com/s/files/1/0653/3621/3722/files/29521-loading.gif?v=1681895601" alt="Loader"><span>Products Loading... </span></div>');
   $.ajax({ 
  url: "https://svc-1001-usf.hotyon.com/search",
  dataType: 'json',
  data: query,
  success: function( res ) {
    
    var resultJSON = $.parseJSON(JSON.stringify(res));  // Convert to json
    var totalProduct  = resultJSON.data.total;
    var showingProduct = resultJSON.data.items.length;
    var facets = resultJSON.data.facets;
    
    $(".count_items").html(totalProduct);
    
    for(var f=0; f < resultJSON.data.facets.length; f++){
        $("#MoreFilters .designer_multiselector .inner-wrap").html("No Designer Found");
        $("#filtersBackdrop .designer_multiselector .inner-wrap").html("No Designer Found");
      if(facets[f].id == "2041182555"){
       //let labels = facets[f].labels;
        let labels = [{"label":"Tacori"}, {"label":"Verragio"}, {"label":"Genesis Designs"}, {"label":"A. Jaffe"}, {"label":"Gabriel & Co"}, {"label":"Simon G."}, {"label":"Fana"}, {"label":"Noam Carver"}, {"label":"Kirk Kara"}];
       
        let designer_html = '';
        let footer_designer_html = '';
        if(labels.length > 0){
          for(let l=0; l < labels.length; l++){
           designer_html += '<a href="#"><label>'+
              			  '<input type="checkbox" class="ckkBox" name="designer_name" value="'+labels[l].label+'" onChange="designerChange()">'+
              			  '<span>'+labels[l].label+'</span>'+
              			'</label></a><br>';

           footer_designer_html += '<label>'+
              			  '<a href="#"><input type="checkbox" class="ckkBox" name="designer_name" value="'+labels[l].label+'" onChange="footerdesignerChange()">'+
              			  '<span>'+labels[l].label+'</span>'+
              			'</label></a><br>';
          }
      
        }

        function footerdesignerChange(){
      $("#MoreFilters input[name='designer_name']").prop('checked', false);
     $("#filtersBackdrop input[name='designer_name']:checked").each(function(){
       var designer_name = $(this).val();
       $("#MoreFilters input[name='designer_name'][value='"+designer_name+"']").prop('checked', true);
    
     });
    getSelectedVal(1);
}
        
        $("#MoreFilters .designer_multiselector .inner-wrap").html(designer_html);
        $("#filtersBackdrop .designer_multiselector .inner-wrap").html(footer_designer_html);
         var designer = getUrlParameter('designer');
          if($.trim(designer) != ""){   
    
        $("input[name='designer_name']").prop("checked", false);
          var designerArray = designer.split(',');
          for (var i = 0; i < designerArray.length; ++i) {
            $("input[name='designer_name'][value='"+designerArray[i]+"']").prop("checked", true);
          } 
    
    
      }else{
        $("input[name='designer_name']").prop("checked", false);
      }
  

      }


  
  $('.ckkBox').change(function() {
  
    toggleCheckedAll(this);
    setCheckboxSelectLabels(); 
  });

  
function setCheckboxSelectLabels(elem) {
  var wrappers = $('.wrapper'); 
   $(".designer_multiselector").find('button').text("Select");
  $.each( wrappers, function( key, wrapper ) {
    var checkboxes = $(wrapper).find('.ckkBox');
    var label = $(wrapper).find('.checkboxes').attr('id');
    var prevText = '';
    var numberOfChecked = $(wrapper).find('input:checked').length;
  
    var count =0 ;
    if(numberOfChecked > 2){

    $.each( checkboxes, function( i, checkbox ) {
      var button = $(wrapper).find('button');
  
      if( $(checkbox).prop('checked') == true) {
            count ++;
        var text = $(checkbox).next().html();
     
        var btnText = prevText + text;
        prevText = btnText + ', ';
          if(count == 2){
            $(button).text(btnText + "..."); 
       }
      }
    });
  
    }
    else{
    $.each( checkboxes, function( i, checkbox ) {
      var button = $(wrapper).find('button');
  
      if( $(checkbox).prop('checked') == true) {
            count ++;
        var text = $(checkbox).next().html();
       
        var btnText = prevText + text;
        $(button).text(btnText); 
        prevText = btnText + ', ';
      }
    });
 }
  });
}
function toggleCheckedAll(checkbox) {
  var apply = $(checkbox).closest('.wrapper').find('.apply-selection');
  apply.fadeIn('slow'); 
  
  var val = $(checkbox).closest('.checkboxes').find('.val');
  var all = $(checkbox).closest('.checkboxes').find('.all');
  var ckkBox = $(checkbox).closest('.checkboxes').find('.ckkBox');

  if(!$(ckkBox).is(':checked')) {
    $(all).prop('checked', true);
    return;
  }

  if( $(checkbox).hasClass('all') ) {
    $(val).prop('checked', false);
  } else {
    $(all).prop('checked', false);
  }
}
  

var a = document.querySelectorAll(".circleMetal li");
for (var i = 0, length = a.length; i < length; i++) {
  a[i].onclick = function() {
    var b = document.querySelector(".circleMetal li.active");
    if (b) b.classList.remove("active");
    this.parentNode.classList.add('active');
  };
}


      if(facets[f].facetName == "price"){
        var maxPrice = facets[f].max;
        var minPrice = facets[f].min;
          var input12 = document.querySelector(".budget-num-end");
          var budgetPress = document.querySelector(".budget-range");
          var budgetMinPress = document.querySelector(".budget-range-min");
          var input11 = document.querySelector(".budget-num-start");
          var input12 = document.querySelector(".budget-num-end");

        
         
          var price_min = getUrlParameter('price_min');
          var price_max = getUrlParameter('price_max');
        if($.trim(price_min) != "" && $.trim(price_max) != ''){
          start_value = price_min;
          end_value = price_max;
        }else{
           start_value = minPrice;
          end_value = maxPrice;
         
        }
          var inputs = [input11, input12];
        // var start_value = $(".budget-num-start").val();
          //var end_value = $(".budget-num-end").val();
        //  start_value = parseFloat(start_value.replace('$ ', '').replace(/,/g, ''));
          //end_value = parseFloat(end_value.replace('$ ', '').replace(/,/g, ''));
        if(start_value < minPrice){
          start_value = minPrice;
        }
         if(end_value > maxPrice){
          end_value = maxPrice;
        }
         budgetPress.noUiSlider.updateOptions({
            start: [start_value,end_value],
              range: {
                min: minPrice,
                max: maxPrice
              }
            }, false);
         budgetMinPress.noUiSlider.updateOptions({
              start: [start_value,end_value],
              range: {
                min: minPrice,
                max: maxPrice
              }
            }, false);
   $("#advFilter input.budget-num-start").val("$ " + Number(start_value).toLocaleString('en')).change();
   $("#advFilter input.budget-num-end").val("$ " + Number(end_value).toLocaleString('en')).change();
       }
      
    }    
    
    $(".showing_product").html('');
    if(showingProduct > 0 ){
      $(".showing_product").html("Showing "+ (skip + 1)+" to "+ (showingProduct + skip) +" of " + totalProduct +"  items");
    }
    
   if(totalProduct > showingProduct || totalProduct > 0 ){ 
    $('.usf_pagination').pagination({
        items: totalProduct,
        itemsOnPage: itemsPerPage,
        prevText: '<svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 13L2 7.16667L9 0.75" stroke="#092B2F" stroke-width="1.5"/></svg>',
        nextText: '<svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 13L8 7.16667L1 0.75" stroke="#092B2F" stroke-width="1.5"/></svg>',
        currentPage:page,
        onPageClick: function (pageNumber) {
           var currentURL = window.location.search;
          var newurl = currentURL;
             if(pageNumber > 1 ){
             newurl = addOrUpdateUrlParam(newurl, 'page', pageNumber);    
              window.location.href= newurl;
          }else{
            
             newurl = removeParam("page", newurl); 
              window.location.href= newurl;
          }
           /*$('html, body').animate({
       scrollTop: ($("#ProductGridContainer").offset().top)
     }, 00);*/
         //  $(".usf_pagination .page-link").attr('href', "javascript:void()");
         
        }
    });
    
   //   $(".usf_pagination .page-link").attr('href', "javascript:void()");

          $(".usf_pagination .page-link").each(function(){
       var page_no = $(this).attr('href');
       
       var str = page_no;
str = str.replace("#page-", "");
         var currentURL1 = window.location.href;
          var newurl1 = currentURL1;
             if(str > 1 ){
             newurl1 = addOrUpdateUrlParam(newurl1, 'page', str);    
             
             }
       else{
           newurl1 = removeParam("page", newurl1); 
           
       }
       $(this).attr('href', newurl1);
     });
   }else{
      $('.usf_pagination').html(""); 
   }



      
       $("#ProductGridContainer #product-grid").html('');
    if(totalProduct > 0 && showingProduct > 0){

        
       $("#ProductGridContainer .collection--empty").hide();
       var gridHtml = '';
       gridHtml +=  '<ul id="product-grid" data-id="template--16776875901146__166479147655a3e8eb" class="grid product-grid grid--2-col-tablet-down grid--4-col-desktop">';
      
       var itemsArray =  resultJSON.data.items;
      for(var i=0; i < itemsArray.length; i++){
        console.log("item-use",itemsArray[i])

        var item = itemsArray[i];

         for( var m=0; m < item.metafields.length; m++){
           if(item.metafields[m].key == "ring_designer"){
             designer_name = item.metafields[m].value;
           }
         }

         /*****   Advertisement Block   ******/
      if(advertisementJson.length > 0){
     
        for (var ad = 0; ad < advertisementJson.length; ad++){

          var adType = advertisementJson[ad].type;
          var adUrl = advertisementJson[ad].url;
          var position = advertisementJson[ad].position;
          var alt = advertisementJson[ad].alt;
          var link = advertisementJson[ad].link;
          var repeat = advertisementJson[ad].repeat;
          var columnwidth = advertisementJson[ad].columnwidth;

          
        }
    
        
  if(repeat && i > 0){
    if( (skip + i) % (position - 1) == 0){
            if(adType == 'image'){
             gridHtml +=  '<li class="grid__item advertisement ad_block col_width_'+(columnwidth * 25)+'">'+
                             '<a href="/products/'+item.urlName+'?shape='+ shape +'"><img src="'+adUrl+'" alt="'+alt+'"></a>'+
                           '</li>';
            }else if(adType== 'video'){
              
                          
                  gridHtml +=  '<li class="grid__item advertisement ad_block col_width_'+(columnwidth * 25)+'" >'+
                               '<a href="/products/'+item.urlName+'?shape='+ shape +'">'+
                            '<video class="video-player__video" preload="auto" playsinline="" autoplay="" muted="" loop="" js-video-player="video">'+
                              '<source type="video/mp4" data-loaded="desktop" data-mobile="'+adUrl+'" data-desktop="'+adUrl+'" js-video-player="source" src="'+adUrl+'">'+
                              '</video>'+
                         '</a>'+
                           '</li>';

            }
            }
            
          
  }else{
     if( skip + i == (position - 1)){

            if(adType == 'image'){
             gridHtml +=  '<li class="grid__item advertisement ad_block col_width_'+(columnwidth * 25)+'">'+
                             '<a href="/products/'+item.urlName+'?shape='+ shape +'"><img src="'+adUrl+'" alt="'+alt+'"></a>'+
                           '</li>';
            }else if(adType== 'video'){
              
                          
                  gridHtml +=  '<li class="grid__item advertisement ad_block col_width_'+(columnwidth * 25)+'" >'+
                               '<a href="/products/'+item.urlName+'?shape='+ shape +'">'+
                            '<video class="video-player__video" preload="auto" playsinline="" autoplay="" muted="" loop="" js-video-player="video">'+
                              '<source type="video/mp4" data-loaded="desktop" data-mobile="'+adUrl+'" data-desktop="'+adUrl+'" js-video-player="source" src="'+adUrl+'">'+
                              '</video>'+
                         '</a>'+
                           '</li>';

            }
            
          }
        }
      }
          /*****   Advertisement Block 2  ******/
      if(advertisementJson2.length > 0){
     
        for (var ad = 0; ad < advertisementJson2.length; ad++){

          var adType = advertisementJson2[ad].type;
          var adUrl = advertisementJson2[ad].url;
          var position = advertisementJson2[ad].position;
          var alt = advertisementJson2[ad].alt;
          var link = advertisementJson2[ad].link;
          var repeat = advertisementJson2[ad].repeat;
          var columnwidth = advertisementJson2[ad].columnwidth;

          
        }
    
        
  if(repeat && i > 0){
    if( (skip + i) % (position - 1) == 0){
            if(adType == 'image'){
             gridHtml +=  '<li class="grid__item advertisement ad_block col_width_'+(columnwidth * 25)+'">'+
                             '<a href="/products/'+item.urlName+'?shape='+ shape +'"><img src="'+adUrl+'" alt="'+alt+'"></a>'+
                           '</li>';
            }else if(adType== 'video'){
              
                          
                  gridHtml +=  '<li class="grid__item advertisement ad_block col_width_'+(columnwidth * 25)+'" >'+
                               '<a href="/products/'+item.urlName+'?shape='+ shape +'">'+
                            '<video class="video-player__video" preload="auto" playsinline="" autoplay="" muted="" loop="" js-video-player="video">'+
                              '<source type="video/mp4" data-loaded="desktop" data-mobile="'+adUrl+'" data-desktop="'+adUrl+'" js-video-player="source" src="'+adUrl+'">'+
                              '</video>'+
                         '</a>'+
                           '</li>';

            }
            }
            
          
  }else{
     if( skip + i == (position - 1)){

            if(adType == 'image'){
             gridHtml +=  '<li class="grid__item advertisement ad_block col_width_'+(columnwidth * 25)+'">'+
                             '<a href="/products/'+item.urlName+'?shape='+ shape +'"><img src="'+adUrl+'" alt="'+alt+'"></a>'+
                           '</li>';
            }else if(adType== 'video'){
              
                          
                  gridHtml +=  '<li class="grid__item advertisement ad_block col_width_'+(columnwidth * 25)+'" >'+
                               '<a href="/products/'+item.urlName+'?shape='+ shape +'">'+
                            '<video class="video-player__video" preload="auto" playsinline="" autoplay="" muted="" loop="" js-video-player="video">'+
                              '<source type="video/mp4" data-loaded="desktop" data-mobile="'+adUrl+'" data-desktop="'+adUrl+'" js-video-player="source" src="'+adUrl+'">'+
                              '</video>'+
                         '</a>'+
                           '</li>';

            }
            
          }
    }
      }
          /*****   Advertisement Block 3  ******/
      if(advertisementJson3.length > 0){
     
        for (var ad = 0; ad < advertisementJson3.length; ad++){

          var adType = advertisementJson3[ad].type;
          var adUrl = advertisementJson3[ad].url;
          var position = advertisementJson3[ad].position;
          var alt = advertisementJson3[ad].alt;
          var link = advertisementJson3[ad].link;
          var repeat = advertisementJson3[ad].repeat;
          var columnwidth = advertisementJson3[ad].columnwidth;

          
        }
    
        
  if(repeat && i > 0){
    if( (skip + i) % (position - 1) == 0){
            if(adType == 'image'){
             gridHtml +=  '<li class="grid__item advertisement ad_block col_width_'+(columnwidth * 25)+'">'+
                             '<a href="/products/'+item.urlName+'?shape='+ shape +'"><img src="'+adUrl+'" alt="'+alt+'"></a>'+
                           '</li>';
            }else if(adType== 'video'){
              
                          
                  gridHtml +=  '<li class="grid__item advertisement ad_block col_width_'+(columnwidth * 25)+'" >'+
                               '<a href="/products/'+item.urlName+'?shape='+ shape +'">'+
                            '<video class="video-player__video" preload="auto" playsinline="" autoplay="" muted="" loop="" js-video-player="video">'+
                              '<source type="video/mp4" data-loaded="desktop" data-mobile="'+adUrl+'" data-desktop="'+adUrl+'" js-video-player="source" src="'+adUrl+'">'+
                              '</video>'+
                         '</a>'+
                           '</li>';

            }
            }
            
          
  }else{
     if( skip + i == (position - 1)){

            if(adType == 'image'){
             gridHtml +=  '<li class="grid__item advertisement ad_block col_width_'+(columnwidth * 25)+'">'+
                             '<a href="/products/'+item.urlName+'?shape='+ shape +'"><img src="'+adUrl+'" alt="'+alt+'"></a>'+
                           '</li>';
            }else if(adType== 'video'){
              
                          
                  gridHtml +=  '<li class="grid__item advertisement ad_block col_width_'+(columnwidth * 25)+'" >'+
                               '<a href="/products/'+item.urlName+'?shape='+ shape +'">'+
                            '<video class="video-player__video" preload="auto" playsinline="" autoplay="" muted="" loop="" js-video-player="video">'+
                              '<source type="video/mp4" data-loaded="desktop" data-mobile="'+adUrl+'" data-desktop="'+adUrl+'" js-video-player="source" src="'+adUrl+'">'+
                              '</video>'+
                         '</a>'+
                           '</li>';

            }
            
          }
    }
      } 

         gridHtml +=  '<li class="grid__item card_'+item.id+'">';
        const product_label = item.metafields.find(field => field.key === 'label');
         if(product_label) gridHtml += '<div class="product-label">'+product_label.value+'</div>';

        const product_label_discount = item.metafields.find(field => field.key === 'label_discount');
         if(product_label_discount) gridHtml += '<div class="product-label-discount">'+product_label_discount.value+'</div>';
        
         // gridHtml +=  '<a href="/products/'+item.urlName+'?shape='+ shape +'">'+
          gridHtml +=  '<div class="card-wrapper cardPro">';
         gridHtml +=  '<div class="card border-0 card--card card--media color-background-1 gradient" style="--ratio-percent: 100.0%;">';
         gridHtml +=  '<div class="card__inner  ratio" style="--ratio-percent: 100.0%;">';
        // gridHtml +=  '<div class="quick_view_wrapper"><button class="quick_view_btn" data-bs-toggle="modal" data-bs-target="quickVIewModal" data-href="'+item.urlName+'">Quick View</button></div>'; 


        
        // start - color-image-group-color /////////////////////
        gridHtml +=  '<div class="card__media">';


       const firstRingMetal = item.variants.find(variant => 
            variant.metafields.some(metafield => metafield.key === "jewellery_ring_metal")
        )?.metafields.find(metafield => metafield.key === "jewellery_ring_metal")?.value;

        
       const colorFromSplitFirst = getColorByMetalType(firstRingMetal);
        
        const urlImageDef = item?.images[0]?.url;
        const selecetdImage = getFirstSec(item.images,colorFromSplitFirst);


        if (selecetdImage.first_image == "") {
          first_image = urlImageDef;
        }
        if (selecetdImage.hover_next_image_url == "") {
          hover_next_image_url = selecetdImage.hover_next_image_url_opt2 || urlImageDef;
        }

        
        // Generating HTML
        const hover_next_image = `<img src="${selecetdImage.hover_next_image_url}" class="secound--image" width="330">`;
        
        if (selecetdImage.hover_next_image_url) {
          gridHtml += `<div class="media media--transparent media--hover-effect media--hover-effect--${item.id}">`;
        } else {
          gridHtml += '<div class="media">';
        }
        
          if (item.images.length > 0) {
            gridHtml += `<img src="${selecetdImage.first_image}" alt="${item.title}" data-variant="${item.variants[0]}" data-arr="" class="motion-reduce" width="330" height="330" id="img${item.id}" data-file-code="usf_setting_collection_search--.js">`;
          }
          
          gridHtml +=  '</div>';
          gridHtml += hover_next_image
         gridHtml +=  '</div>';


         // end - color image product /////////////////////



        
        var wishlist_class = "";
        if(isProductInWishlist(item.id)){
          wishlist_class = 'fa-solid';
        }
        gridHtml +=  '<div class="wishlist_heart" >' +
        
         '<span onclick="addToWishlistNewFunc()" class="addToWishlistIcon addToWishlistIconNew fa-regular fa-heart fa-2xl '+wishlist_class+'" data-wishlist-product-url="/products/'+item.urlName+'" data-wishlist-product-id="'+item.id+'" data-wishlist-variant-id="'+item.variants[0].id+'" data-wishlist-variantimage="'+item.images[0].url+'" data-wishlist-product-name="'+item.title+'" data-wishlist-product-image="' +urlImageDef+ '" data-wishlist-variantprice="'+item.variants[0].price+'"></span>      '+
      '</div>';
        
  
          gridHtml +=  '<a href="/products/'+item.urlName+'?shape='+ shape +'" aria-labelledby="StandardCardNoMediaLink-template--16776875901146__166479147655a3e8eb-7838713217242 NoMediaStandardBadge-template--16776875901146__166479147655a3e8eb-7838713217242">'+
            '<div class="card__content">'+
                        '<div class="card__information text-center">'+
                          '<h3 class="card__heading">'+
                              item.title +
                          '</h3>'+
                        '</div>';       
                     
                   var tags = item.tags;
                 
                  $.each(tags, function(i, val) {
                     
                      if (val.indexOf("label_") >= 0) {
                         labelName = val.split("label_");
                          gridHtml +=   '<div class="card__badge top left">'+
                                      '<span class="badge badge--bottom-left color-inverse">'+labelName[1]+'</span>'+
                                      '</div>';
                      }
                  });
       
      

              if(item.options.length >  0){
                 var options = item.options[0].values;
              }
        
                 gridHtml +=    '</div>'+
                              '</div></a>'+
                             '<div class="card__content">'+
                              '<div class="card__information text-center p-0 p-lg-4">';
           var shape = getUrlParameter('diamond');
          if($.trim(shape) != ""){
            shape = shape.toLowerCase();
          }else{
            shape = 'round';
          }

       if(item.images.length > 0){
          var img = item.images;
          var white_image = '';
          var yellow_image = '';
          var rose_image = '';
          var silver_image = '';
          var two_toned_white_yellow_image = '';
          var two_toned_white_rose_image = '';
          
          for(var m=0; m < img.length; m++){
            if(!img[m].url.includes("Hand")){
              var img_url = img[m].url;
            }else {
              var img_url_with_hand = img[m].url;
              
            }
            src_array = img_url.split('/');
            src = src_array[src_array.length-1].toLowerCase();
            
    
            
            if( src.indexOf('white_') != -1 && white_image === ''){
              var white_image = img_url;
              var white_img_name= 'white_'+ ucFirst(shape);
            }
             if( src.indexOf('yellow') != -1 && yellow_image === ''){
              var yellow_image = img_url;
              var yellow_img_name= 'yellow_'+ ucFirst(shape);
            }
             if(  src.indexOf('_rose') != -1 && rose_image === ''){
              
              var rose_image = img_url;
              var rose_img_name= 'rose_'+ ucFirst(shape);
            }
             if(  src.indexOf('silver') != -1 && silver_image === ''){
           
              var silver_image = img_url;
              var silver_img_name= 'silver_'+ ucFirst(shape);
            }
             if(  src.indexOf('two-tone') != -1 && two_toned_white_yellow_image === ''){
           
              var two_toned_white_yellow_image = img_url;
              var two_toned_white_yellow_img_name= 'silver_'+ ucFirst(shape);
            }
             if(  src.indexOf('white-rose') != -1 && two_toned_white_rose_image === ''){
           
              var two_toned_white_rose_image = img_url;
              var two_toned_white_rose_img_name= 'two_toned_white_rose_'+ ucFirst(shape);
            }
          }
        }

          function ucFirst(str) {
            if (!str) return str;

            return str[0].toUpperCase() + str.slice(1);
          }
  const prioritizedMetals = [
              '14K White Gold',
              '14K Yellow Gold',
              '14K Rose Gold',
              '14K Two-Tone Gold',
              '14K White Gold / Rose Gold',
              '14K White / Rose Gold',
              '18K White Gold',
              '18K Yellow Gold',
              '18K Rose Gold',
              '18K Two-Tone Gold',
              '18K White Gold / Rose Gold',
              '18K White / Rose Gold',
              'Platinum', 
          ];
        
          var itemprice = item.variants[0].price;
          var itemCompareAtPrice = item.variants[0].compareAtPrice;
        
          if (item.options.length > 0) {
              gridHtml += '<div class="row metalBlock">' +
                  '<div class="col-12">' +
                  '<div class="">';
              
            let variant = item.variants;
            var default_image = item.images[0].url;
            // Loop through prioritized metals
            var countingMetalShow = 0;
            for (const metal of prioritizedMetals) {

                    
                      for (let v = 0; v < variant.length; v++) {
                          console.log(variant[v],"variant[v]")
                        
                          const ringMetalField = variant[v].metafields.find(field => field.key === 'jewellery_ring_metal');
                          
                        const ringMetalValue = ringMetalField?.value ?? "";


                        
                        
                          if (ringMetalValue == metal) {
                              countingMetalShow += 1;
                              let img_index = variant[v].imageIndex;
                              let variantImage = '';
                              let classColor = '';
                              let valueColor = '';
                              // Set the appropriate image
                              if (item.images.length > 0 && img_index >= 0) {
                                  variantImage = item.images[img_index].url;
                                
                              } 
                              if (metal.includes('Two-Tone Gold')){
                                 classColor = "two_toned_white_yellow" 
                                  valueColor = "Two Toned White Yellow";
                                  variantImage = two_toned_white_yellow_image || default_image;
                              }else if (metal.includes('White Gold / Rose Gold')){
                                 classColor = "two_toned_white_rose"
                                  valueColor = "Two Toned White Rose";
                                  variantImage = two_toned_white_rose_img_name || default_image;
                              }else if (metal.includes('White / Rose Gold')){
                                 classColor = "two_toned_white_rose"
                                  valueColor = "Two Toned White Rose";
                                  variantImage = two_toned_white_rose_img_name || default_image;
                              }else if (metal.includes('White Gold')) {
                                  classColor = "white_image";
                                  
                                  valueColor = "White Gold";
                                  variantImage = white_image || default_image;
                              } else if (metal.includes('Yellow Gold')) {
                                  classColor = "yellow_image";
                                  valueColor = "Yellow Gold";
                                  variantImage = yellow_image || default_image;
                              } else if (metal.includes('Rose Gold')) {
                                  classColor = "rose_image";
                                  valueColor = "Rose Gold";
                                  variantImage = rose_image || default_image;
                              } else if (metal.includes('Platinum')) {
                                  classColor = "white_image"
                                  valueColor = "Platinum";
                                  variantImage = white_image || default_image;
                              
                              } else if (item.images.length > 0) {
                                  variantImage = item.images[0].url;
                              }
          
                              let variantID = variant[v].id;
                              let variantPrice = variant[v].price;
                              let variantCompareAtPrice = variant[v].compareAtPrice;
                              
                              // Add to gridHtml
                              gridHtml += '<div class="form-check form-check-inline p-0">' +
                                  `<input 
                                    class="form-check-input metal_option ${classColor}" 
                                    type="radio" 
                                    name="inlineMetal_${item.id}" 
                                    value="${valueColor}" 
                                    data-metal="${metal}" data-val="index_${options.indexOf(metal)}" data-imgurl="${variantImage}" 
                                    data-varid="${variantID}" 
                                    data-price="${variantPrice}" 
                                    data-compareatprice="${variantCompareAtPrice}"
                                    data-imgname="${metal.replace(/ /g, '_').toLowerCase()}_img_name" data-check="D">` +
                                  '</div>';                                  
                          }
                      }
                  // }
                 if (countingMetalShow > 2) {
                      break;
                  }
              };
          
              gridHtml += '</div>' +
                  '</div>' +
                  '</div>';
          }
// if(item.options.length >  0){
//                        var itemprice = item.variants[0].price;
//                       gridHtml +=          '<div class="row metalBlock">'+
//                                         '<div class="col-12">'+
//                                             '<div class="">';
//                                                         if(options.indexOf('Silver') > -1 || options.indexOf('PLATINUM') > -1 || options.indexOf('STERLING SILVER') > -1 || options.indexOf('18K AND STERLING SILVER') > -1 ||options.indexOf('Platinum') > -1 || options.indexOf('Sterling Silver') > -1 || options.indexOf('18K And Sterling Silver') > -1){
//                                                       var variant = item.variants;
//                                                            var variantImage = '';
                                                      
//                                                       for(var v=0; v < variant.length ; v++){
//                                                        if(options.indexOf('Silver') > -1  || options.indexOf('PLATINUM') > -1|| options.indexOf('STERLING SILVER') > -1 || options.indexOf('18K AND STERLING SILVER') > -1  || options.indexOf('Platinum') > -1 || options.indexOf('Sterling Silver') > -1 || options.indexOf('18K And Sterling Silver') > -1 ){
                                             
//                                                           var img_index = variant[v].imageIndex;
//                                                            var variantImage = '';
                                                         
                                                       
//                                                            if(item.images.length > 0 && img_index >= 0){

//                                                              var variantImage = item.images[img_index].url;
                                                           
//                                                            }else if(silver_image != ''){
//                                                              variantImage = silver_image;
//                                                            }
//                                                            else if(item.images.length > 0){
//                                                                variantImage = item.images[0].url;
//                                                            }
//                                                           var variantID = variant[v].id;
//                                                           var variantPrice = variant[v].price;
//                                                         }
//                                                       }
                                                      
//                                                  gridHtml +=    '<div class="form-check form-check-inline p-0">'+
//                                                               '<input class="form-check-input metal_option" type="radio" name="inlineMetal_'+ item.id +'" value="Silver" data-val="índex_' + options.indexOf('Silver') +'" data-imgurl="'+variantImage+'" data-varid="'+ variantID +'" data-price="'+variantPrice+'" data-imgname="'+white_img_name+'">'+
//                                                                 '</div>';
//                                                }

//                                                   if(options.indexOf('Yellow Gold') > -1 || options.indexOf('18K YELLOW GOLD') > -1 || options.indexOf('YELLOW GOLD') > -1 || options.indexOf('14K YELLOW GOLD') > -1 || options.indexOf('10K YELLOW GOLD') > -1 || options.indexOf('18K Yellow Gold') > -1 || options.indexOf('14K Yellow Gold') > -1 || options.indexOf('10K Yellow Gold') > -1){
//                                                    var variant = item.variants;
                                                      
//                                                       for(var v=0; v < variant.length ; v++){
//                                                          if(options.indexOf('Yellow Gold') == variant[v].options[0] || options.indexOf('18K YELLOW GOLD') == variant[v].options[0] || options.indexOf('YELLOW GOLD') == variant[v].options[0] || options.indexOf('14K YELLOW GOLD') == variant[v].options[0] || options.indexOf('10K YELLOW GOLD') == variant[v].options[0]  || options.indexOf('18K Yellow Gold') == variant[v].options[0] || options.indexOf('14K Yellow Gold') == variant[v].options[0] || options.indexOf('10K Yellow Gold') == variant[v].options[0]){
                                                   
//                                                           var img_index = variant[v].imageIndex;
//                                                            var variantImage = '';
                                                              
//                                                            if(item.images.length > 0 && img_index > 0){
//                                                                variantImage = item.images[img_index].url;
//                                                            }else if(yello_image != ''){
//                                                              variantImage = yello_image;
//                                                            }else if(item.images.length > 0){
//                                                                variantImage = item.images[0].url;
//                                                            }
//                                                           var variantID = variant[v].id;
//                                                           var variantPrice = variant[v].price;
//                                                         }
//                                                       }
                                                      
//                                                  gridHtml +=    '<div class="form-check form-check-inline p-0">'+
//                                                                      '<input class="form-check-input metal_option  yellow_gold" type="radio" name="inlineMetal_'+ item.id +'" value="Yellow Gold" data-val="índex_' + options.indexOf('Yellow Gold') +'" data-imgurl="'+variantImage+'" data-varid="'+ variantID +'" data-price="'+variantPrice+'"  data-imgname="'+yellow_img_name+'">'+  
//                                                    '</div>';
                                             
//                                                }

//                                                   if(options.indexOf('Rose Gold') > -1 || options.indexOf('ROSE GOLD') > -1 || options.indexOf('18K ROSE GOLD') > -1 || options.indexOf('14K ROSE GOLD') > -1 || options.indexOf('10K ROSE GOLD') > -1  ||  options.indexOf('18K Rose Gold') > -1 || options.indexOf('14K Rose Gold') > -1 || options.indexOf('10K Rose Gold') > -1){
//                                                     var variant = item.variants;
                                                      
//                                                       for(var v=0; v < variant.length ; v++){
//                                                         if(options.indexOf('Rose Gold') == variant[v].options[0] || options.indexOf('18K ROSE GOLD') == variant[v].options[0] || options.indexOf('ROSE GOLD') == variant[v].options[0] || options.indexOf('14K ROSE GOLD') == variant[v].options[0] || options.indexOf('10K ROSE GOLD') == variant[v].options[0] || options.indexOf('18K Rose Gold') == variant[v].options[0] || options.indexOf('14K Rose Gold') == variant[v].options[0] || options.indexOf('10K Rose Gold') == variant[v].options[0]){
//                                                           var img_index = variant[v].imageIndex;
//                                                            var variantImage = '';
                                                           
//                                                            if(item.images.length > 0 && img_index > 0){
//                                                             variantImage = item.images[img_index].url;
//                                                           }else if(rose_image != ''){
//                                                              variantImage = rose_image;
//                                                            }else if(item.images.length > 0){
//                                                                variantImage = item.images[0].url;
//                                                            }
//                                                           var variantID = variant[v].id;
//                                                           var variantPrice = variant[v].price;
//                                                         }
//                                                       }
                                             
                                                      
//                                                  gridHtml +=    '<div class="form-check form-check-inline p-0">'+
//                                                                     '<input class="form-check-input metal_option rose_gold" type="radio" name="inlineMetal_'+ item.id +'" value="Rose Gold" data-val="índex_' + options.indexOf('Rose Gold') +'" data-imgurl="'+variantImage+'" data-varid="'+ variantID +'" data-price="'+variantPrice+'"  data-imgname="'+rose_img_name+'">'+
//                                                    '</div>';
//                                                }

//                                                  if(options.indexOf('White Gold') > -1 || options.indexOf('WHITE GOLD') > -1 || options.indexOf('18K WHITE GOLD') > -1 || options.indexOf('14K WHITE GOLD') > -1 || options.indexOf('10K WHITE GOLD') > -1 || options.indexOf('18K White Gold') > -1 || options.indexOf('14K White Gold') > -1 || options.indexOf('10K White Gold') > -1){
                                              
//                                                    var variant = item.variants;
                                                      
//                                                       for(var v=0; v < variant.length ; v++){
//                                                         if(options.indexOf('White Gold') == variant[v].options[0] || options.indexOf('18K WHITE GOLD') == variant[v].options[0] || options.indexOf('WHITE GOLD') == variant[v].options[0] || options.indexOf('14K WHITE GOLD') == variant[v].options[0] || options.indexOf('10K WHITE GOLD') == variant[v].options[0] || options.indexOf('18K White Gold') == variant[v].options[0] || options.indexOf('14K White Gold') == variant[v].options[0] || options.indexOf('10K White Gold') == variant[v].options[0]){
//                                                         var img_index = variant[v].imageIndex;
//                                                            var variantImage = '';
//                                                            if(item.images.length > 0 && img_index > 0){
//                                                              variantImage = item.images[img_index].url;
//                                                          }else if(white_image != ''){
//                                                              variantImage = white_image;
                                                           
//                                                            }else if(item.images.length > 0){
//                                                                variantImage = item.images[0].url;
//                                                            }
//                                                           var variantID = variant[v].id;
//                                                           var variantPrice = variant[v].price;
//                                                         }
//                                                       }
                                                      
//                                                  gridHtml +=    '<div class="form-check form-check-inline p-0">'+
//                                                                     '<input class="form-check-input metal_option white_gold" type="radio" name="inlineMetal_'+ item.id +'" value="White Gold" data-val="índex_' + options.indexOf('White Gold') +'" data-imgurl="'+variantImage+'" data-varid="'+ variantID +'" data-price="'+variantPrice+'"  data-imgname="'+white_img_name+'">'+
//                                                    '</div>';
//                                                }


  
//                                                 if(options.indexOf('Two Toned') > -1 || options.indexOf('14K TWO TONE GOLD') > -1 || options.indexOf('18K TWO TONE GOLD') > -1 || options.indexOf('14K WHITE GOLD / ROSE GOLD') > -1 || options.indexOf('14K Two Tone Gold') > -1 || options.indexOf('18K Two Tone Gold') > -1 || options.indexOf('14K White Gold / Rose Gold') > -1 ){
//                                                     var variant = item.variants;
                                                      
//                                                       for(var v=0; v < variant.length ; v++){
//                                                         if(options.indexOf('Two Toned') == variant[v].options[0] || options.indexOf('14K TWO TONE GOLD') == variant[v].options[0] || options.indexOf('18K TWO TONE GOLD') == variant[v].options[0] || options.indexOf('14K WHITE GOLD / ROSE GOLD') == variant[v].options[0]  || options.indexOf('14K Two Tone Gold') == variant[v].options[0] || options.indexOf('18K Two Tone Gold') == variant[v].options[0] || options.indexOf('14K White Gold / Rose Gold') == variant[v].options[0] ){
//                                                           var img_index = variant[v].imageIndex;
//                                                            var variantImage = '';
//                                                            if(item.images.length > 0 && img_index > 0){
//                                                             variantImage = item.images[img_index].url;
//                                                            }else if(item.images.length > 0){
//                                                                variantImage = item.images[0].url;
//                                                            }
//                                                           var variantID = variant[v].id;
//                                                           var variantPrice = variant[v].price;
//                                                         }
//                                                       }
                                                      
//                                                  gridHtml +=    '<div class="form-check form-check-inline p-0">'+
//                                                                     '<input class="form-check-input metal_option rose_gold" type="radio" name="inlineMetal_'+ item.id +'" value="Rose Gold" data-val="índex_' + options.indexOf('Rose Gold') +'" data-imgurl="'+variantImage+'" data-varid="'+ variantID +'" data-price="'+variantPrice+'"  data-imgname="'+rose_img_name+'">'+
//                                                    '</div>';
//                                                }
        
        
                                                
//                                           gridHtml +=    '</div>'+
//                                         '</div>'+
//                                     '</div>';
//                  }

 






        
                             gridHtml +=     '<a href="/products/'+item.urlName+'?shape='+ shape +'" aria-labelledby="CardLink-template--16776875901146__166479147655a3e8eb-7838713217242 Badge-template--16776875901146__166479147655a3e8eb-7838713217242" data-producthandle="'+item.urlName+'">'+
                               '<h3 class="card__heading h5">'+
                                  
                                      item.title +
                                
                                '</h3>'+
                               // '<div class="designer_name">'+designer_name+'</div>'+
                                '<div class="card-information text-center"><span class="caption-large light"></span>'+
                      '<div class="price ">'+
                        '<div class="price__container">'+
                            '<span class="price-item price-item--regular">'+ 
                              '$'+ itemprice.toLocaleString() +
                            '</span>';
         if(itemCompareAtPrice > itemprice){
        
            gridHtml +=      '<span class="compare-at-price" data>'+ 
                                 '$'+ itemCompareAtPrice.toLocaleString() +
                            '</span>';
        }
         gridHtml +=    '</div></div></div>'+
                                 '</a>'+
                              '</div>';
        
        gridHtml +=          '</div>'+
                          '</div>'+
                        '</div>'+   
                     '</li>';
      }
      gridHtml +=  '</ul>';

      $("#ProductGridContainer #product-grid").html(gridHtml).show();

      if(metal != ""){
        metal = metal;
      }else{
        metal = "Platinum";
      }


 $(".quick_view_btn").click(function(){
        let item_handle = $(this).attr("data-href");
        $("#quickVIewModal").modal('show');
        $("#pro_quick_view_container").html('<div class="loader"><img src="https://cdn.shopify.com/s/files/1/0653/3621/3722/files/29521-loading.gif?v=1681895601" alt="Loader"></div>');
      
        let var_id = $(this).parents(".card__inner").next().find(".card__information").find(".metalBlock").find(".metal_option:checked").attr("data-varid");
     var var_image = $(this).parents(".card__inner").next().find(".card__information").find(".metalBlock").find(".metal_option:checked").attr("data-imgname");
          if(typeof var_image == "undefined"){
                              var_image = $(this).parents(".card__inner").next().find(".card__information").find(".metalBlock").find(".metal_option[checked='checked']").attr("data-imgname");
                          
                           }
   $.ajax({
                url: '/products/'+item_handle+'?variant='+var_id+'&view=quick_view',
                type: "GET",
                success: function(datas){
                    $("#pro_quick_view_container").html(datas);

                   $("#shopify-section-main-product-quick-view .j-img-wrapper").css('opacity', '0');

          
                                          
                        $("button#select_setting").click(function(){
                          const size = $(".j-size-dropdown-container select").val();
                          const productUrl = $(this).attr('data-producturl');
                          const varId = $("#quickVIewModal .j-metal.j-active").attr('data-variant-id');
                             
                          if(size == null){
                              $(".j-size-dropdown-container select").addClass('error');
                          }else{
                            let SettingProduct = {
                              "handle":productUrl, 
                              "variant_id":varId, 
                              "ring_size":size
                            };

                             localStorage.setItem("setting_product_select", JSON.stringify(SettingProduct));
                             var selected_shape = $("input[name='diamond_shape']:checked").val();

                             if(step == 'diamond'){
                                      window.location.href="/pages/personalize-your-ring";
                                   }else{
                                     window.location.href="/collections/diamond-collection?diamond_shape=" + selected_shape; 
                                   }
                          
                          }
                        });

                         $(".j-size-dropdown-container select").change(function(){
                           $(this).removeClass('error');
                         });
                                   
                                          
                         setTimeout(function(){

                            var metal_type = var_image;
                         
                       

                                               $("#shopify-section-main-product-quick-view .j-img").each(function(){
                                                var imgName = $(this).attr('data-img');
                                                 if(imgName.indexOf(metal_type) >= 0){
                                                   
                                                     $(this).addClass('showit');
                                                   $(this).css('opacity', '1');
                                                   $("#shopify-section-main-product-quick-view .j-img-wrapper").css('opacity', '1');
                                                   // return false;
                                                 }

                                               });


                       }
             , 500);


                    
                },
                error: function(err){
                    console.error(err, "error from wishlist displaying products");
                }
            });
        });
      $("#quickVIewModal .close_modal").click(function(){
         $("#quickVIewModal").modal('hide');
      });


        $("li.grid__item input.metal_option[value='"+metal+"']").each(function(){
          $(this).attr("checked", true);
          var imgurl = $(this).data("imgurl");
          var varid = $(this).data("varid");
          var price = $(this).data("price");
          var compareAtPrice = $(this).data("compareatprice");
          
          var currentURL = window.location.href.split('?')[0];  

          $(this).parents(".card--media").find(".card__inner").find(".card__media").find(".media").find("img").attr("src", imgurl);
          $(this).parents(".card__information").find(".card-information").find(".price-item").html("$"+ price.toLocaleString() );
          if(compareAtPrice > price){
            $(this).parents(".card__information").find(".card-information").find(".compare-at-price").html("$"+ compareAtPrice.toLocaleString() );
          }else{
            $(this).parents(".card__information").find(".card-information").find(".compare-at-price").html("");
            
          }
          
          var link = $(this).parents(".card__information").find("a");
          var producthandle = link.data("producthandle");
          var productUrl = currentURL + "/products/" + producthandle + "?variant=" + varid + "&shape=" + ucFirst(shape);
          link.attr('href', productUrl);
          
          var wishlistIcon = $(this).parents(".card--media").find(".card__inner").find(".card__content").find(".wishlist_heart").find("span").find(".addToWishlistIcon")
          
          wishlistIcon.attr("data-wishlist-variant-id", varid);
          wishlistIcon.attr("data-wishlist-variantimage", imgurl);
          wishlistIcon.attr("data-wishlist-variantprice", price);
         
          checkWishlistProduct(wishlistIcon, varid);      
        });
        

        $("input.metal_option").change(function(){
          console.log("test-sc-g")
          
          var imgurl = $(this).data("imgurl");
          var varid = $(this).data("varid");
          var price = $(this).data("price");
          var compareAtPrice = $(this).data("compareatprice");
          
          var item_id = $(this).attr('name').split('_')[1];
          console.log("test-sc-g")
          document.querySelector(`.media--hover-effect--${item_id}`).classList.remove('media--hover-effect');

    

          var currentURL = window.location.href.split('?')[0];  

          $(this).parents(".card--media").find(".card__inner").find(".card__media").find(".media").find("img").attr("src", imgurl);
          $(this).parents(".card__information").find(".card-information").find(".price-item").html("$"+ price.toLocaleString() );
          var link = $(this).parents(".card__information").find("h3.card__heading").find("a");
          var producthandle = link.data("producthandle");
          var productUrl = currentURL + "/products/" + producthandle + "?variant=" + varid + "&shape=" + ucFirst(shape);
          link.attr('href', productUrl);
          
          
           const wishlistElement = document.querySelector('[data-wishlist-product-id="'+item_id+'"]');
          
          wishlistElement.setAttribute("data-wishlist-variant-id", varid);
          wishlistElement.setAttribute("data-wishlist-variantimage", imgurl);
          wishlistElement.setAttribute("data-wishlist-variantprice", price);

          // checkWishlistProduct(wishlistIcon, varid);

        });

      function checkWishlistProduct(wishlistIcon, varid){
        
          wishListDetails = $.parseJSON(localStorage.getItem("wishListDetails"));
     
        
        var productid = wishlistIcon.data("wishlist-product-id");
        
        if(wishListDetails != null){

            if(localStorage.getItem("loginUsrWishlistProducts") != null){
             userwishProductsDetails = $.parseJSON(localStorage.getItem("loginUsrWishlistProducts"));
             let userwishProductArr = userwishProductsDetails.wishlistProductId;
             let userwishProductVariantArr = userwishProductsDetails.wishlistVariantId;
             wishlistIcon.removeClass('fa-solid').addClass("fa-regular");
            if(productid){
              if(userwishProductArr.includes(productid.toString()) && userwishProductVariantArr.includes(varid.toString())){
          // if(userwishProductArr.includes(productid.toString())){
                 wishlistIcon.removeClass('fa-regular').addClass('fa-solid');
             }
            }
          }
          
        }else{
        
          if(localStorage.getItem("guestUsrWishlistProducts") != null){
             userwishProductsDetails = $.parseJSON(localStorage.getItem("guestUsrWishlistProducts"));
             let userwishProductArr = userwishProductsDetails.wishlistProductId;
             let userwishProductVariantArr = userwishProductsDetails.wishlistVariantId;
             wishlistIcon.removeClass('fa-solid').addClass("fa-regular");
            if(userwishProductArr.length > 0){
              $("span.wishlist_count").html(userwishProductArr.length);
            }
            if(userwishProductArr.includes(productid.toString()) && userwishProductVariantArr.includes(varid.toString())){
          // if(userwishProductArr.includes(productid.toString()) ){
                 wishlistIcon.removeClass('fa-regular').addClass("fa-solid");
             }
          }
        }
      
      }
      
    }else{
      $("#ProductGridContainer .collection--empty").show();
    }

    

  }
});
 
 
}

/***   URL Parameter Update ****/

function addOrUpdateUrlParam(uri, paramKey, paramVal) {
  var re = new RegExp("([?&])" + paramKey + "=[^&#]*", "i");
  if (re.test(uri)) {
    uri = uri.replace(re, '$1' + paramKey + "=" + paramVal);
  } else {
    var separator = /\?/.test(uri) ? "&" : "?";
    uri = uri + separator + paramKey + "=" + paramVal;
  }
  return uri;
}

 function getUrlParameter(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}
function removeParam(key, sourceURL) {
    var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
}

$(document).ready(function(){

  initLoadScript();
  
  $("select[name='sortBy']").change(function() {
    $(".sortListP a.list-group-item").removeClass("active");
    var sortValue = $(this).val();
    $(".sortListP a.list-group-item[data-value='"+sortValue+"']").addClass("active");
    getSelectedVal();
  });

  $(".sortListP a.list-group-item").click(function(){
    $(".sortListP a.list-group-item").removeClass("active");
    var sortValue = $(this).data('value');
    $(this).addClass("active");
    $("select[name='sortBy']").val(sortValue);
     getSelectedVal();
  });
 

  
   $("input[name='inlineRadioMetal']").change(function() {
    var metal_name = $(this).val();
     $("input[name='inlineRadioMetal2'][value='"+metal_name+"']").prop('checked', true);
    getSelectedVal(1);
  });

   $("input[name='inlineRadioMetal2']").change(function() {
    var metal_name = $(this).val();
     $("input[name='inlineRadioMetal'][value='"+metal_name+"']").prop('checked', true);
    getSelectedVal(1);
  });

  $("#shopStyle input[name='style']").change(function(e) {
  
    var style_name = $(this).val();
    $(".shopfiltermin input[name='style']").prop('checked', false);
     $("#shopStyle input[name='style']:checked").each(function(){
       var style = $(this).val();
       $(".shopfiltermin input[name='style'][value='"+style+"']").prop('checked', true);
     });

  
    getSelectedVal(1);
  });

  $(".shopfiltermin input[name='style']").change(function(e) {
  
    var style_name = $(this).val();
    $("#shopStyle input[name='style']").prop('checked', false);
     $(".shopfiltermin input[name='style']:checked").each(function(){
       var style = $(this).val();
       $("#shopStyle input[name='style'][value='"+style+"']").prop('checked', true);
     });

  
    getSelectedVal(1);
  });

    $("#diamondShape input[name='diamond_shape']").change(function(e) {
  
    var shape_name = $(this).val();
    $(".diamondfiltermin input[name='diamond_shape1']").prop('checked', false);
     $("#diamondShape input[name='diamond_shape']:checked").each(function(){
       var shape = $(this).val();
       $(".diamondfiltermin input[name='diamond_shape1'][value='"+shape+"']").prop('checked', true);
     });

  
    getSelectedVal(1);
  });

  $(".diamondfiltermin input[name='diamond_shape1']").change(function(e) {
  
    var shape_name = $(this).val();
    $("#diamondShape input[name='diamond_shape']").prop('checked', false);
     $(".diamondfiltermin input[name='diamond_shape1']:checked").each(function(){
       var shape = $(this).val();
       $("#diamondShape input[name='diamond_shape'][value='"+shape+"']").prop('checked', true);

     });

  
    getSelectedVal(1);
  });

  
  
$("select[name='itemsPerPage']").change(function(){
  var itemsPerPage = $(this).val();
   $("select[name='itemsPerPage']").val(itemsPerPage); 
  getSelectedVal();
});
  $( ".noUi-handle" ).mouseup(function() {

    var min_budget = $("#MoreFilters .budget-num-start").val();
  var max_budget = $("#MoreFilters .budget-num-end").val();
  min_budget = parseFloat(min_budget.replace('$ ', '').replace(/,/g, ''));
  max_budget = parseFloat(max_budget.replace('$ ', '').replace(/,/g, ''));

   $("input.budget-num-start").val("$ " + Number(min_budget).toLocaleString('en')).change();
    $("input.budget-num-end").val("$ " + Number(max_budget).toLocaleString('en')).change();
 
    getSelectedVal();
  });
  
let budgetMinPress = document.querySelector(".budget-range-min");
  let budgetPress = document.querySelector(".budget-range");
let input25 = document.querySelector("#advFilter .budget-num-start");
let input26 = document.querySelector("#advFilter .budget-num-end");
let input27 = document.querySelector("#MoreFilters .budget-num-start");
let input28 = document.querySelector("#MoreFilters .budget-num-end");
let inputs = [input25, input26];
let moreinputs = [input27, input28];
  
budgetMinPress.noUiSlider.on("update", function(values, handle) {
  inputs[handle].value = values[handle];
  

  });
budgetMinPress.noUiSlider.on("set", function(values, handle) {
  moreinputs[handle].value = values[handle];
   getSelectedVal();
  });
budgetPress.noUiSlider.on("set", function(values, handle) {
  inputs[handle].value = values[handle];
   getSelectedVal();
  });
 

  $(".reset_filter").click(function(){
    
    var currentURL = window.location.href.split('?')[0];  
   window.history.pushState(null, '', currentURL);
    $('input[name="style"],input[name="inlineRadioMetal"]').prop("checked", false);
    $('input[name="style"],input[name="inlineRadioMetal2"]').prop("checked", false);
    $('input[name="diamond_shape"]').prop("checked", false);
    $('input[name="designer_name"]').prop("checked", false);
     $(".designer_multiselector").find('button').text("Select");
  
    getSelectedVal(1);
  });

});
 document.addEventListener('click', function(event) {
    if (event.target.classList.contains('metal_option')){
     const tabClick = event.target;
      console.log(tabClick)
      // Extract data attributes
      var imgurl = tabClick.getAttribute("data-imgurl");
      var varid = tabClick.getAttribute("data-varid");
      var price = parseFloat(tabClick.getAttribute("data-price"));
      var item_id = tabClick.getAttribute('name').split('_')[1];
      console.log("test-sc-g");
      
      // Remove class from target element
      document.querySelector(`.media--hover-effect--${item_id}`).classList.remove('media--hover-effect');
      
      // Get the current URL without query parameters
      var currentURL = window.location.href.split('?')[0];
      
      // Update the image source
      var cardMedia = tabClick.closest(".card--media");
      var imgElement = cardMedia.querySelector(".card__media .media img");
      if (imgElement) {
          imgElement.src = imgurl;
      }
      
      // Update the price text
      var cardInformation = tabClick.closest(".card__information");
      var priceElement = cardInformation.querySelector(".card-information .price-item");
      if (priceElement) {
          priceElement.innerHTML = "$" + price.toLocaleString();
      }
      
      // Update the product link
      var link = cardInformation.querySelector("h3.card__heading a");
      if (link) {
          var producthandle = link.getAttribute("data-producthandle");
          var productUrl = `${currentURL}/products/${producthandle}?variant=${varid}&shape=${ucFirst(shape)}`;
          link.setAttribute('href', productUrl);
      }
      
      // Update wishlist attributes
      var wishlistIcon = cardMedia.querySelector(".wishlist_heart .addToWishlistIcon");
      if (wishlistIcon) {
          wishlistIcon.setAttribute("data-wishlist-variant-id", varid);
          wishlistIcon.setAttribute("data-wishlist-variantimage", imgurl);
          wishlistIcon.setAttribute("data-wishlist-variantprice", price);
      }

    }
 });

function designerChange() {
    $("#filtersBackdrop input[name='designer_name']").prop('checked', false);
     $("#MoreFilters input[name='designer_name']:checked").each(function(){
       var designer = $(this).val();
       $("#filtersBackdrop input[name='designer_name'][value='"+designer+"']").prop('checked', true);
     }); 
    getSelectedVal(1);
  }

function footerdesignerChange(){
      $("#MoreFilters input[name='designer_name']").prop('checked', false);
     $("#filtersBackdrop input[name='designer_name']:checked").each(function(){
       var designer_name = $(this).val();
       $("#MoreFilters input[name='designer_name'][value='"+designer_name+"']").prop('checked', true);
    
     });
    getSelectedVal(1);
}
function imgURL(src, size) {
  // remove any current image size then add the new image size
  return src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.').replace(/\.jpg|\.png|\.gif|\.webp|\.jpeg/g, function(match) {
      return '_'+size+match;
    })
  ;
}
    function noForward(event) {
        event.stopPropagation(); // Prevents the event from bubbling up to the anchor link
    }


function addToWishlistNewFunc(){
  console.log("addToWishlistNew")
  
  var buttonWS = event.target;
  console.log(buttonWS)
  
  var dwpid = buttonWS.getAttribute("data-wishlist-product-id");
  var dwpname = buttonWS.getAttribute("data-wishlist-product-name");
  var dwpimg = buttonWS.getAttribute("data-wishlist-product-image");
  var dwvid = buttonWS.getAttribute("data-wishlist-variant-id");
  var dwprice = buttonWS.getAttribute("data-wishlist-variantprice");
  var dwlink = buttonWS.getAttribute("data-wishlist-product-url"); 
  buttonWS.classList.add('fa-solid');

  
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || {
      wishlistProducts: [],
      wishlistVariants: []
  };

  if (!isProductInWishlist(dwpid)) {
    const product_details = {
      product_id: dwpid,
      product_name: dwpname,
      product_image: dwpimg,
      variant_id: dwvid,
      price: dwprice,
      link: dwlink
    }
    wishlist.wishlistProducts.push(product_details);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
    updateWishlistCount()
  console.log("Updated wishlist:", wishlist);
  }else{
    removeFromWishlistByProductId(dwpid);
    buttonWS.classList.remove('fa-solid');
    updateWishlistCount()    
  }
  

  
}
function isProductInWishlist(productId) {
    // Get the wishlist from localStorage
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || {
        wishlistProducts: [],
        wishlistVariants: []
    };
  var existingProduct = false;
  
  if(wishlist.wishlistProducts){
   wishlist.wishlistProducts.forEach(e => {
     if(e.product_id == productId){
       existingProduct = true;
     }
   })
  }

    // Check if the product ID exists in wishlistProductId
    return existingProduct
}
function isVariantInWishlist(variantId) {
    // Get the wishlist from localStorage
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || {
        wishlistProducts: [],
        wishlistVariants: []
    };
  var existingProduct = false;
  
  if(wishlist.wishlistProducts){
   wishlist.wishlistProducts.forEach(e => {
     if(e.variant_id == variantId){
       existingProduct = true;
     }
   })
  }

    // Check if the product ID exists in wishlistProductId
    return existingProduct
}

function removeFromWishlistByProductId(productIdToRemove) {
    // Retrieve wishlist from localStorage
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || {
        wishlistProducts: [],
        wishlistVariantId: []
    };

    if (wishlist.wishlistProducts && wishlist.wishlistProducts.length > 0) {
        // Create a new array excluding the product to be removed
        let updatedWishlistProducts = [];
        
        wishlist.wishlistProducts.forEach((product) => {
            if (product.product_id !== productIdToRemove) {
                updatedWishlistProducts.push(product);
            }
        });

        // Assign updated array to wishlist
        wishlist.wishlistProducts = updatedWishlistProducts;
    }

    // Save the updated wishlist back to localStorage
    localStorage.setItem("wishlist", JSON.stringify(wishlist));

    console.log("Updated wishlist after removal:", wishlist);
}
  function updateWishlistCount() {
      let wishlistData = localStorage.getItem("wishlist");
      let wishlistCountElement = document.querySelector(".wishlist_count");
  
      if (wishlistData) {
          let wishlist = JSON.parse(wishlistData);
          let totalCount = (wishlist.wishlistProducts ? wishlist.wishlistProducts.length : 0) +
                           (wishlist.wishlistVariants ? wishlist.wishlistVariants.length : 0);
          wishlistCountElement.textContent = totalCount;
      } else {
          wishlistCountElement.textContent = 0;
      }
  }
